<script setup lang="ts">
import MessageImageAttachment from './MessageImageAttachment.vue';

/** 答案卡示意图：进入可视区才读取，点开看大图；图注写在图下方。 */
const props = defineProps<{
  id: string;
  caption?: string;
  load: (id: string) => Promise<Blob>;
  /** 身份变化时作废在途请求。 */
  scope?: unknown;
}>();
</script>

<template>
  <figure class="knowledge-image" data-testid="knowledge-image" :data-kb-image="props.id" :data-kb-caption="props.caption || ''">
    <MessageImageAttachment
      :attachment="{ id: props.id, name: props.caption || '示意图', mime: 'image/png', size: '0' }"
      :scope="props.scope"
      :load="() => props.load(props.id)"
    />
    <figcaption v-if="props.caption">{{ props.caption }}</figcaption>
  </figure>
</template>

<style scoped>
.knowledge-image { margin: 6px 0; }
.knowledge-image :deep(.message-image) { width: 100%; max-width: 360px; margin: 0; }
/* 系统截图多为宽图：按原比例铺满气泡宽度，点开看原图。 */
.knowledge-image :deep(.image-attachment-thumbnail--message) { width: 100%; height: auto; }
.knowledge-image :deep(.image-attachment-thumbnail--message img) { height: auto; max-height: 240px; }
.knowledge-image figcaption { margin-top: 2px; color: #7b8793; font-size: 12px; }
</style>
